import { create } from "zustand";

interface TrackingState {
  trackingConsent: boolean;
  setTrackingConsent: (consent: boolean) => void;
}

export const useTrackingStore = create<TrackingState>((set) => ({
  trackingConsent: false,
  setTrackingConsent: (consent: boolean) => set({ trackingConsent: consent }),
}));
